import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ElementFormService {

  /** Form state. */
  private _dirty$ = new BehaviorSubject<boolean>(false);

  /** Form state. */
  public dirty$ = this._dirty$.asObservable();

  /** Dispatched action. */
  private _action$ = new Subject<'cancel' | 'submit'>();

  /** Dispatched action. */
  public action$ = this._action$.asObservable();

  /**
   * Dispatch action for the *cancel* button.
   */
  public cancel(): void {
    this._action$.next('cancel');
  }

  /**
   * Check if the current form is dirty.
   *
   * @return Whether the form is dirty.
   */
  public isDirty(): boolean {
    let dirty: boolean;
    this.dirty$.pipe(first()).subscribe(d => dirty = d);
    return dirty;
  }

  /**
   * Set the form to dirty/pristine.
   *
   * @param dirty: Whether the new state is dirty or not.
   */
  public setIsDirty(dirty: boolean): void {
    this._dirty$.next(dirty);
  }

  /**
   * Dispatch action the *submit* button.
   */
  public submit(): void {
    this._action$.next('submit');
  }
}
